import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { imageIcon } from "../data/imagePath";

export function SideMenuItems({ item, activeMenu, setActiveMenu }) {
  const location = useLocation();
  const navigate = useNavigate();
  const submenuRef = useRef(null);

  // Check if any submenu item is active based on the current route
  const isSubMenuActive = item.submenu?.some(
    (subItem) => location.pathname === subItem.path
  );
  const isMenuActive = item.submenu?.some(
    (item) => location.pathname === item.path
  );
  const isSubMenuOpen = activeMenu === item.title;

  // Keep submenu open if any submenu item is active
  useEffect(() => {
    if (isSubMenuActive) {
      setActiveMenu(item.title);
    }
  }, [isSubMenuActive, item.title, setActiveMenu]);

  const handleMenuClick = () => {
    // Toggle submenu: close if open, open if closed
    setActiveMenu(isSubMenuOpen ? null : item.title);
  };

  return (
    <div className={`sideMenu-item ${isSubMenuOpen ? "openActive" : ""}`}>
      {item.path ? (
        <Link
          to={item.path}
          className={`submenu_item sigleLink  ${
            location.pathname === item.path ? "navActive" : ""
          }`}
          style={{ paddingLeft: "10px" }}>
          <img
            src={imageIcon[item.icon]}
            alt=""
            className="submenu_icon"
          />
          <span className="suLinknk">{item.title}</span>
        </Link>
      ) : (
        <div
          className={`sideLink ${isSubMenuActive ? "navActive" : ""}`}
          onClick={handleMenuClick} // Toggles menu open/close
        >
          <div className="sideLink_item">
            <img
              src={imageIcon[item.icon]}
              alt=""
              className="sidelink_icon"
            />
            <span>{item.title}</span>
          </div>
          {item.submenu && (
            <img
              src={imageIcon.sideRight}
              alt=""
              className="sideArrow"
            />
          )}
        </div>
      )}
      {item.submenu && (
        <ul
          className={`submenu ${isSubMenuOpen ? "active" : ""}`}
          ref={submenuRef}
          style={{
            height: isSubMenuOpen ? submenuRef.current?.scrollHeight : 0,
          }}>
          {item.submenu.map((subItem, index) => (
            <Link
              key={index}
              className={`submenu_item ${
                location.pathname === subItem.path ? "navActive" : ""
              }`}
              to={subItem.path}>
              <img
                className="submenu_icon"
                src={imageIcon[subItem.icon]}
                alt=""
              />
              <div className="suLinknk">{subItem.title}</div>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}
